import { createContext } from "react";
import { BarcodeSettingsContextType, StreamContextType } from "./types";

export const BarcodeSettingsContext = createContext<
  BarcodeSettingsContextType | undefined
>(undefined);

export const StreamContext = createContext<StreamContextType | undefined>(
  undefined
);
